import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { formatCurrency } from '../../../../../helpers/numbers'

import { selectedTikTokAdAccountSelector } from '../../../../../modules/selectors/adAccounts'

import { BUDGET } from '../../../../Tiktok/LineItemForms/LineItemTikTokEdit/fields'
import { BUDGET_MODE_TOTAL, BUYING_TYPE } from '../../../../Tiktok/fields'

const TikTokCampaignBudgetSectionPreview = ({ campaign }) => {
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const { [BUDGET]: budget } = campaign

  const formattedBudget = formatCurrency(budget, { min: 2, max: 2 }, { symbol: currencySymbol })
  const budgetTypeLabel = campaign[BUYING_TYPE] === BUDGET_MODE_TOTAL ? t('Lifetime') : t('Daily')

  if (budget) {
    return (
      <p>
        {formattedBudget} ({budgetTypeLabel})
      </p>
    )
  }

  if (!budget) {
    return <p>{t('Using ad group budgets')}</p>
  }

  return null
}

export default TikTokCampaignBudgetSectionPreview
